import React from 'react';
import { connect } from 'react-redux';
import BrowseSearchPage from './BrowseSearchPage.component';
import { getLinkType, getRules } from '../../reducers/feature.reducer';

export const mapStateToProps = (state, ownProps) => {
  const { pathname } = ownProps.location;
  const querystring = ownProps.location.search;
  const pageType = pathname.includes('/b/') ? 'b' : 's';
  const { sValue } = ownProps.match.params;
  const linkType = getLinkType({ state: state.feature, page: pageType, tag: 'product_pod' });
  const parts = pathname.split('/');
  const nValue = parts.find(p => /^N-/.test(p));
  const nttParam = parts.find(p => /^Ntt-/.test(p));
  const ntkParam = parts.find(p => /^Ntk-/.test(p));

  return {
    linkType,
    pathname,
    nValue,
    nttParam,
    sValue,
    pageType,
    querystring,
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    push: ownProps.history.push,
    replace: ownProps.history.replace
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrowseSearchPage);
